import React from 'react';
import classNames from 'classnames';
import { Clinic } from './vetClinicResponse';

const VetClinicCard = ({ clinic, isSearch = false }: { clinic: Clinic; isSearch?: boolean }) => {
  const cardInfoClassName = classNames('pet-form-vet-card__info', {
    'pet-form-vet-card__padding': !isSearch,
  });
  return (
    <ul className={cardInfoClassName}>
      <li className="pet-form-vet-card__info--name">{clinic.name}</li>
      {!!clinic.address &&
        !!clinic.address.city &&
        !!clinic.address.state &&
        !!clinic.address.postcode && (
          <li className="pet-form-vet-list__info">
            {!!clinic.address.street1 && <> {clinic.address.street1}</>}
            {!clinic.address.street2 ? <>, </> : <>, {clinic.address.street2}, </>}
            {!isSearch ? (
              <span className="pet-form-vet-list__info">
                {clinic.address.city}, {clinic.address.state} {clinic.address.postcode}
              </span>
            ) : (
              <>
                {clinic.address.city}, {clinic.address.state} {clinic.address.postcode}
              </>
            )}
          </li>
        )}
      {!!clinic.address && !!clinic.address.phone1 && (
        <li className="pet-form-vet-card__info--phone">
          <span>{clinic.address.phone1}</span>
        </li>
      )}
    </ul>
  );
};

export default VetClinicCard;
